export var Type = {
  Default: 'default',
  Suggested: 'suggested'
};